import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class PolicityService {

  pdf: any
  pdfFile: any;

  constructor(public api: ApiService) { 

      this.api.query('cliente/PoliticaPrivacidade', {}, 'get')?.subscribe((data: any) => {

          this.pdf = this._base64ToArrayBuffer(data.Conteudo)
          this.pdfFile = data.Conteudo

      })

  }

  getPolicyPrivacity(){
    return this.pdf
  }
  
  download(){

    const source = 'data:application/pdf;base64,' +this.pdfFile;

    const link = document.createElement("a");
    link.href = source;
    link.download = `SabemiDigitalPoliticaDePrivacidade.pdf`
    link.click();

  }

  _base64ToArrayBuffer(base64:any) {

      var binary_string = base64.replace(/\\n/g, '');
      binary_string =  window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array( len );
      for (var i = 0; i < len; i++)        {
          bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;

   }

}
